import axios from 'axios';  
import React, { useEffect, useState } from 'react';  
import { Link, useNavigate } from 'react-router-dom';  
import { useToken } from '../contex/TokenProvider';
import { AiOutlineLoading3Quarters } from "react-icons/ai"; 
import '../Style/FeaturedProperty.css';
import BaseUrl from '../api/BaseUrl';

const FeaturedProperties = () => {  
  const {token} = useToken();

  const [properties, setProperties] = useState([]);  
  const [selectedProperties, setSelectedProperties] = useState([]);  
  const [error, setError] = useState('');  
  const [errorSelect, setErrorSelect] = useState(''); 
  const [loading, setLoading] = useState(true); 
  const [message, setMessage] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const navigate = useNavigate();  

  useEffect(() => { 
    setError('');
    const fetchProperties = async () => {   
      setLoading(true); // Start loading  
      try {  
        const response = await BaseUrl.get('/Property/get-all-properties', {
          headers: {  
            'Authorization': `Bearer ${token}`  
          }
        });  
        setProperties(response.data.data);
        //console.log(response.data); // Use 'data' from the response  
      } catch (err) {  
        console.error('Error fetching properties:', err);  
        setError('Error fetching properties')
      } finally {  
        setLoading(false); // Stop loading  
      }  
    };  

    fetchProperties();  
  }, []);  

  const handleSelectProperty = (propertyId) => {  
    setMessage('');
    if (selectedProperties.includes(propertyId)) {  
      // Remove ID from selectedIds  
      setSelectedProperties(selectedProperties.filter(selectedProperty => selectedProperty !== propertyId));
      setError('');
    }else if (selectedProperties.length < 3) {  
        setSelectedProperties((prev) => [...prev, propertyId]);  
        console.log(selectedProperties);
    } else {  
        setError('You can only select three properties');  
    }  
}; 
    

const handleSubmit = async () => {  
  setErrorSelect(''); 
  setMessage('');  
  setButtonLoading(true);
  const requestPayload = { propertyIds: selectedProperties };   

  try {  
    const response = await BaseUrl.post('/Property/set-featured-properties', requestPayload, {  
        headers: {  
            'Authorization': `Bearer ${token}`,  
        }  
    });  
    if(response.data.success) {  
        setMessage(response.data.message);  
    }  
    setSelectedProperties([]); 
  } catch (err) { 
    let mess = '';
    if(err.response){
      if(err.response.status === 401){
        mess = 'System error. Please refresh and try again later';
      } else if(err.response.status === 500){
        mess = 'Internal server error.';
      }else (
        mess = err.response.data.message || mess
      )
    } 
    setErrorSelect(mess); 
  }finally{
    setButtonLoading(false);
  }  
};  

const handleCancelSelection = () => {  
  setSelectedProperties([]);  
  setError(''); 
  setErrorSelect('');
  setMessage('');
};

  return (  
    <div className='mx-[200px] py-[100px]'>  
      <div className='flex flex-row justify-between items-center py-10'>  
        <h1 className='text-[20px] font-bold'>Featured Properties</h1>  
        {error && <p className="text-red-500 text-[18px]">{error}</p>}     
        <Link to={'/home'}>  
          <button className='px-3 py-1 bg-green-500 text-white rounded-lg'>Back</button>  
        </Link>  
      </div>  
      <div className='flex flex-col'>  
        {loading ? (  
          <p>Loading properties...</p>  
        ) : (
          <div>
            {properties.map((property, index) => {
              return(
                <div key={property.propertyId} className='flex flex-row justify-between gap-10 border-t-4 border-b-4 py-5 '>  
              <div onClick={() => navigate(`/viewfeturedproperties/${property.propertyId}`)} className='max-w-[300px] hover:shadow-lg cursor-pointer'>  
                <img className='w-[100%]' src={property.image} alt={property.title} />  
              </div>  
              <div className='flex flex-row gap-10 items-center justify-between'>  
                <div className='flex flex-col gap-2'>  
                  <h1>{property.title}</h1>  
                  <p>{property.address}</p>  
                  <p>{property.description}</p>  
                </div>  
                
              </div> 
              
              <div>  
                <button  
                  className="bg-green-500 text-white px-2 py-1 rounded hover:cursor-pointer"  
                  onClick={() => handleSelectProperty(property.propertyId)} 
              >  
                  {selectedProperties.includes(property.propertyId) ? 'Selected' : 'Select'}  
                </button>  
              </div>   
            </div>
              )
            })}
          </div>
        )}  
      </div> 
      {error && <p className="text-red-500 text-[18px] mt-5">{error}</p>}
      {errorSelect || message && <p className={`text-[18px] ${errorSelect ? 'text-red-500 text-[18px]' : ''}`}>{errorSelect || message}</p>}

      <div className='flex flex-row gap-5'>
        <button  
            className={`bg-green-500 text-white px-4 py-2 rounded mt-4 cursor-pointer hover:bg-green-400 active:bg-green-600  ${selectedProperties.length < 3 ? 'bg-slate-300 hover:bg-slate-300 cursor-not-allowed' : ''}`}  
            onClick={handleSubmit}  
            disabled={selectedProperties.length < 3}  
        >  
            {buttonLoading ? <AiOutlineLoading3Quarters className='loading w-5 h-3 text-[20px]' /> : "Submit"}  
        </button> 
        <button 
          className={`bg-red-500 text-white px-4 py-2 rounded mt-4 ${selectedProperties.length < 1 ? 'bg-slate-300 cursor-not-allowed' : ''}`} 
          onClick={handleCancelSelection}
          disabled={selectedProperties.length < 1}
        >Deselect All</button>  
      </div>
      
    </div>  
  );  
};  

export default FeaturedProperties;